const Footer = () => {
    return (
        <div className="footer-container row g-0 ">
            <div className="copy-rights col-12 text-center">
                <span className="footer-color">© Tiara Consulting Services, Inc.</span>
        </div>
        </div >
    );
};

export default Footer;
